'use strict';

import ngResource from 'angular-resource';

function GroupActivePowerService ($resource) {
    return $resource(
        '/api/group_active_power/:id',
        { id: '@id' },
        { show  : { method: 'GET',  isArray: false } }
    );
}

export default angular.module('leptonApp.GroupActivePowerService', ['ngResource'])
    .service('GroupActivePowerService', ['$resource', GroupActivePowerService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/group_active_power/group_active_power.service.js